/**
 * 线上支付冻结目录（T6）。暂不对接微信/支付宝，禁止删除本文件与挂载的占位资源。
 * 人类可读全文：docs/payment-freeze/README.md
 *
 * 后期接支付：先接 SDK 与回调验签，再打开 SCAN_PAY_PLACEHOLDER_VISIBLE，
 * 并把真实付款码传入 RechargeScanPayPlaceholder。不要把意向提交主路径拆掉。
 */

function envFlag(name) {
  const raw = process.env[name];
  if (raw == null || String(raw).trim() === '') return null;
  const value = String(raw).trim().toLowerCase();
  if (value === 'true' || value === '1' || value === 'yes') return true;
  if (value === 'false' || value === '0' || value === 'no') return false;
  return null;
}

/** 用户下单主路径是否展示扫码占位。本期默认 false（提交意向）。 */
const DEFAULT_SCAN_PAY_PLACEHOLDER_VISIBLE = false;

/**
 * 线上支付是否已对接。未接 SDK 前必须为 false；不要用环境变量伪装「已开通」。
 * 接 SDK 后再把实现改成读配置。
 */
export function isOnlinePaymentConnected() {
  return false;
}

/**
 * 是否在充值页 / 结算弹窗重新挂上冻结的扫码占位。
 * 仅影响展示，不表示已收款。可用 REACT_APP_IPE_SCAN_PAY_PLACEHOLDER 临时打开做视觉回归。
 */
export function isScanPayPlaceholderVisible() {
  const fromEnv = envFlag('REACT_APP_IPE_SCAN_PAY_PLACEHOLDER');
  return fromEnv == null ? DEFAULT_SCAN_PAY_PLACEHOLDER_VISIBLE : fromEnv;
}

export const ONLINE_PAYMENT_COPY = {
  qrChannelLabel: '微信',
  scanMethodHint: '微信扫码支付（线上暂未开通，请联系商务）',
};

/**
 * 扫码占位可重新挂上的表面。classPrefix / 文案与现有 CSS 对齐，后期加支付宝表面时在此追加，不要在 JSX 里写死一套。
 */
export const SCAN_PAY_SURFACES = {
  purchase: {
    id: 'purchase',
    classPrefix: 'ipe-credits-purchase-modal',
    qrIconSize: 18,
    intentHint: '提交公司信息后，商务将与您联系开通',
    scanHint: ONLINE_PAYMENT_COPY.scanMethodHint,
  },
  checkout: {
    id: 'checkout',
    classPrefix: 'ipe-recharge-cart-checkout',
    qrIconSize: 22,
    intentHint: '线上支付暂未开通，提交意向后商务将与您联系',
    scanHint: ONLINE_PAYMENT_COPY.scanMethodHint,
  },
};

export function getScanPaySurface(surfaceId) {
  const surface = SCAN_PAY_SURFACES[surfaceId];
  if (!surface) {
    throw new Error(`Unknown scan-pay surface: ${surfaceId}`);
  }
  return surface;
}

export function resolvePayMethodHint(surfaceId) {
  const surface = getScanPaySurface(surfaceId);
  return isScanPayPlaceholderVisible() ? surface.scanHint : surface.intentHint;
}

/** 相对 client/frontend 的冻结路径，供测试防止误删。 */
export const ONLINE_PAYMENT_FROZEN_PATHS = [
  'src/constants/onlinePaymentFreeze.js',
  'src/components/ipe/RechargeScanPayPlaceholder.jsx',
  'src/styles/ipe/ipe-credits-purchase-modal.css',
  'src/styles/ipe/recharge-cart-checkout-modal.css',
  'src/components/ipe/IpeCreditsPurchaseView.jsx',
  'src/components/ipe/RechargeCartCheckoutModal.jsx',
];

/** 支付规划清单 ID。实现状态以后端 OnlinePaymentFreeze 为准；前端只用于对照，不发请求。 */
export const PLANNED_PAYMENT_API_IDS = [
  'wechat.native.create',
  'wechat.native.query',
  'wechat.native.close',
  'wechat.native.refund',
  'wechat.native.notify',
  'alipay.page.pay',
  'alipay.page.query',
  'alipay.page.close',
  'alipay.page.refund',
  'alipay.page.notify',
];

/** 与支付无关，禁止当支付接口清理或改造成收款。 */
export const ONLINE_PAYMENT_OUT_OF_SCOPE = [
  'WeChatLoginService',
  '/ipe-users/wechat/login-session',
  '/ipe-users/wechat/poll',
  'IpeGlobalFloatBalls',
  'QrCodePlugin',
];
